/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

interface TableState extends CommonState {}

const initialState: TableState = {
 ...initialCommonState,
};
const tablesSlice = createSlice({
 name: 'table',
 initialState,
 reducers: commonReducers,
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemsStart,
 deleteItemsSuccess,
 deleteItemsFailure,
 deleteItemsFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,
} = tablesSlice.actions;
export default tablesSlice.reducer;
